import {create} from 'zustand';

interface AnimationState {
  targetRef: React.RefObject<HTMLDivElement> | null;
  setTargetRef: (ref: React.RefObject<HTMLDivElement>) => void;
}

export const useAnimationStore = create<AnimationState>((set) => ({
  targetRef: null,
  setTargetRef: (el) => set({targetRef: el}),
  buttonRef: null,
}));
